import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
	EventFilterType,
	EventOfInterestType,
	NewsEventOfInterest,
	CompaniesWithEvents,
} from 'company-finder-common';
import { DeploymentContext } from '../../utilities/deployment-context/deployment-context.js';

import { ServiceBase } from '../_service.base.js';

@Injectable({ providedIn: 'root' })
export class EventService extends ServiceBase {
	constructor(
		protected _deploymentContext: DeploymentContext,
		protected _httpClient: HttpClient
	) {
		super(_httpClient, _deploymentContext, '/event');
	}

	public unseenCounts: number[];
	public async getUnseenEventCounts(): Promise<number[]> {
		if (!this.unseenCounts) {
			this.unseenCounts = await this.get<number[]>(
				`${this._apiUrl}/user/unread-count`
			);
		}

		return this.unseenCounts;
	}

	public clearUnseenCounts(): void {
		this.unseenCounts = [0, 0, 0, 0];
	}

	public async getUserEventsOfInterestDigest(
		index: number,
		count: number,
		selectedUpdateType: EventOfInterestType = EventOfInterestType.AllUpdates,
		filterTypes: EventFilterType[] = []
	): Promise<CompaniesWithEvents> {
		return this.post<CompaniesWithEvents>(`${this._apiUrl}`, {
			index,
			count,
			selectedUpdateType,
			filterTypes,
		});
	}

	public async getCompanyNewsDigest(
		companyId: string
	): Promise<NewsEventOfInterest[]> {
		return this.get<NewsEventOfInterest[]>(
			`${this._apiUrl}/company/${companyId}`
		);
	}
}
